import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _get } from "../../../api/chatbotApiClient";

const initialState = {
  chatbotHistory: [],
  loading: false,
  error: null,
  page: 1,
  messages: [],
  chatbotIsStreaming: false,
};

export const chatbotHistoryThunk = createAsyncThunk(
  "chatbot/fetchHistory",
  async ({ page = 1 }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();

      const _orgClientId =
        state.orgReducer.selectedFI.orgClientId ??
        state.authReducer?.userData?.client_Id;

      const response = await _get(
        `${_orgClientId}/chat?PageNumber=${page}&PageSize=5`,
        {},
        {},
        {},
      );

      const formattedHistory = response?.data?.data?.data
        .map((item) => {
          const formattedTime = new Date(item.createdOn).toLocaleString(
            "en-US",
            {
              weekday: "long",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            },
          );

          return [
            {
              sender: "user",
              text: item.message,
              createdOn: formattedTime,
            },
            {
              sender: "bot",
              text: item.response,
              createdOn: formattedTime,
            },
          ];
        })
        .flat();

      // await new Promise((resolve) => setTimeout(resolve, 1000));

      return { data: formattedHistory, page };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to load chat history",
      );
    }
  },
);

export const chatbotSlice = createSlice({
  name: "chatbotSlice",
  initialState,
  reducers: {
    setChatbotHistory: (state, action) => {
      state.chatbotHistory.push(...action.payload); // add new messages
    },
    resetChatbotHistory: (state, action) => {
      return initialState;
    },
    addUserMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    addBotMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setStreaming: (state, action) => {
      state.chatbotIsStreaming = action.payload;
    },
    clearChat: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(chatbotHistoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chatbotHistoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        // state.chatbotHistory = action.payload;
        const { data, page } = action.payload;
        if (page === 1) {
          state.chatbotHistory = data;
        } else {
          state.chatbotHistory = [...data, ...state.chatbotHistory];
        }

        state.page = page;
      })
      .addCase(chatbotHistoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setChatbotHistory,
  resetChatbotHistory,
  addUserMessage,
  addBotMessage,
  setStreaming,
  clearChat,
} = chatbotSlice.actions;
export default chatbotSlice.reducer;
